window.site = (window.site || {});

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.HeroSwitch = (function HeroSwitch() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Query DOM elements inside init() after DOMContentLoaded has fired
    const $tailDatetimeFields = [].slice.call(document.querySelectorAll('.tail-datetime-field'));
    const $pristineForms = [].slice.call(document.querySelectorAll('[data-pristine-validation]'));

    // Initialize tail.DateTime for date fields
    console.log('HeroSwitch: tail fields found:', $tailDatetimeFields.length);
    console.log('HeroSwitch: window.tail exists:', typeof window.tail !== 'undefined');
    console.log('HeroSwitch: window.tail.DateTime exists:', window.tail && typeof window.tail.DateTime);

    if ($tailDatetimeFields.length > 0 && typeof window.tail !== 'undefined' && window.tail.DateTime) {
      console.log('HeroSwitch: Initializing tail.DateTime with weekend blackout');
      const $now = new Date();
      const $weekLimit = 4;
      const $endDate = new Date();
      $endDate.setDate($endDate.getDate() + ($weekLimit * 91));

      // Build dateRanges: blacklist weekends, but allow exception dates from CMS
      var weekendExceptions = window.weekendExceptionDates || [];
      var dateRanges;

      if (weekendExceptions.length > 0) {
        // Generate blacklist entries for weekend dates, excluding exceptions.
        // Merge consecutive Sat+Sun into a single range to avoid tail.DateTime
        // silently dropping the second entry when two individual dates are adjacent.
        dateRanges = [];
        var d = new Date();
        d.setHours(0, 0, 0, 0);
        var endLoop = new Date($endDate);
        endLoop.setHours(23, 59, 59, 999);

        // Handle lone Sunday if the loop starts on a Sunday
        if (d.getDay() === 0) {
          var sunIsoFirst = d.getFullYear() + '-' +
            String(d.getMonth() + 1).padStart(2, '0') + '-' +
            String(d.getDate()).padStart(2, '0');
          if (weekendExceptions.indexOf(sunIsoFirst) === -1) {
            dateRanges.push({ start: new Date(d.getTime()), end: new Date(d.getTime()) });
          }
          d.setDate(d.getDate() + 1);
        }

        while (d <= endLoop) {
          var dow = d.getDay();
          if (dow === 6) {
            // Saturday: check if both Sat and Sun should be blacklisted
            var satIso = d.getFullYear() + '-' +
              String(d.getMonth() + 1).padStart(2, '0') + '-' +
              String(d.getDate()).padStart(2, '0');
            var sun = new Date(d.getTime());
            sun.setDate(sun.getDate() + 1);
            var sunIso = sun.getFullYear() + '-' +
              String(sun.getMonth() + 1).padStart(2, '0') + '-' +
              String(sun.getDate()).padStart(2, '0');

            var satBlocked = weekendExceptions.indexOf(satIso) === -1;
            var sunBlocked = weekendExceptions.indexOf(sunIso) === -1;

            if (satBlocked && sunBlocked) {
              // Both blocked: merge into one range
              dateRanges.push({ start: new Date(d.getTime()), end: new Date(sun.getTime()) });
            } else if (satBlocked) {
              dateRanges.push({ start: new Date(d.getTime()), end: new Date(d.getTime()) });
            } else if (sunBlocked) {
              dateRanges.push({ start: new Date(sun.getTime()), end: new Date(sun.getTime()) });
            }
            // Skip Sunday since we already handled it
            d.setDate(d.getDate() + 1);
          }
          d.setDate(d.getDate() + 1);
        }
      } else {
        dateRanges = [{ days: [0, 6] }]; // Default: blacklist all weekends
      }

      var $tail = window.tail.DateTime($tailDatetimeFields, {
        locale: window.site.App.config('locale'),
        animate: true,
        timeHours: false,
        timeMinutes: false,
        timeSeconds: false,
        timeFormat: '',
        today: true,
        dateRanges: dateRanges,
        dateBlacklist: true,
        dateStart: new Date(),
        dateEnd: $endDate,
        dateFormat: window.site.App.config('locale') === 'fr' ? 'dd F YYYY' : 'F dd, YYYY',
      });

      $tailDatetimeFields.forEach(($field) => {
        $field.addEventListener('change', () => {
          var currentDate = $tail.fetchDate();

          $field.nextElementSibling.value = currentDate.getTime();
        }, true);
      });
    }

    if ($pristineForms) {
      const defaultConfig = {
        classTo: 'fields-group',
        errorTextParent: 'fields-group',
        errorTextTag: 'div',
      };

      $pristineForms.forEach($form => {
        var pristine = new Pristine($form, defaultConfig);

        $form.addEventListener('submit', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var valid = pristine.validate();
          
          if (valid) {
            const formData = new FormData($form);
            formData.delete('g-recaptcha-response');

            if ($form.classList.contains('booking-form')) {
              try {
                const action = $form.querySelector('input[name="g-recaptcha-action"]').value;
                const scriptSrc = document.querySelector('script[src*="google.com/recaptcha/api.js"]').src;
                const siteKey = scriptSrc.split('render=')[1];
                const token = await grecaptcha.execute(siteKey, {action: action});

                formData.append('g-recaptcha-response', token);

                $form.classList.add('is-loading');
                const response = await window.axios.post('/actions/site-module/default/booking-study-area', formData);
                $form.classList.remove('is-loading');
          
                if (response.data.status === 'error') {
                  $form.classList.add('has-failed');
                } else {
                  // Redirect to the confirmation page
                  window.location.href = $form.dataset.redirect;
                }
              } catch (error) {
                console.error('Error submitting form:', error);
              }
            } else {
              formData.delete('halte-24-7-csrf');
              formData.delete('__Secure-halte-24-7-csrf');
              const asString = new URLSearchParams(formData).toString();

              window.location.href = `${$form.action}?${asString}`;
            }
          }

          return false;
        }, true);
      });
    }

    let $switch = document.querySelector('.hero-radios');

    if ($switch) {
      let $radios = [].slice.call($switch.querySelectorAll('input[type=radio]'));
      let $homeSection = document.querySelector('#hero-home');

      $homeSection.style.backgroundImage = "url('" + $homeSection.dataset.backgroundMontreal + "')";

      if ($radios) {
        $radios.forEach(($radio) => {
          $radio.addEventListener('change', (e) => {
            let value = $radio.value;
            let $titles = [].slice.call(document.querySelectorAll('.hero-info'));
            let $offers = [].slice.call(document.querySelectorAll('.offers'));
            let $videos = [].slice.call(document.querySelectorAll('.hero-cta'));

            $titles.forEach(($title) => {
              $title.classList.remove('is-active');
            });

            $videos.forEach(($video) => {
              $video.classList.toggle('is-active');
            });


            let $selectedTitle = document.querySelector('.hero-info[data-name=' + value + ']');
            $selectedTitle.classList.add('is-active');

            $offers.forEach(($offer) => {
              $offer.classList.remove('is-active');
            });

            let $selectedOffer = document.querySelector('.offers[data-office=' + value + ']');

            $selectedOffer.classList.add('is-active');

            let $homeSection = document.querySelector('#hero-home');
            if ($homeSection) {
              let $url = '';


              if (value == 'montreal') {
                $url = $homeSection.dataset.backgroundMontreal;
              } else {
                $url = $homeSection.dataset.backgroundLongueuil;
              }

              $homeSection.style.backgroundImage = "url('" + $url + "')";
            }

            let $offersGalleries = [].slice.call(document.querySelectorAll('.offers.is-active .offers-container .offer'));

            if ($offersGalleries) {
              $offersGalleries.forEach(($offer) => {
                let $slider = $offer.querySelector('.offer-gallery');
                let $images = [].slice.call($slider.querySelectorAll('img'));

                if ($images) {
                  var flkty = new Flickity($slider, {
                    // options
                    cellAlign: 'left',
                    contain: true,
                    pageDots: false,
                    imagesLoaded: true,
                    wrapAround: true,
                    lazyLoad: true
                  });
                }
              });
            }
          });
        });
      }
    }

    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}());
